module.exports = __webpack_public_path__ + "img/icon_manual_stock.a2c9e029.png";